import "./instrument";
import React from "react";
import ReactDOM from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import { createGlobalStyle } from "styled-components";
import {
  ViewerProvider,
  ThemeProvider,
  AlertsProvider,
  i18next,
  ToastContainer,
  DropdownProvider,
  TooltipProvider,
  ModalProvider,
} from "dash-ui";
import App from "App";
import { client } from "gql/client";
import { QuickTourProvider } from "common/components/QuickTour";
import { ChecklistProvider } from "common/components/QuickStartChecklist";
import GuideHighlight from "common/components/GuideHighlight";
import reportWebVitals from "reportWebVitals";

import "react-toastify/dist/ReactToastify.min.css";

import "./index.css";
import { GoogleMapsProvider } from "v2/providers/google-maps-provider";
import ConfirmUserTypeModal from "common/components/ConfirmUserTypeModal/ConfirmUserTypeModal";
import { ConfirmSsoNameModal } from "features/confirm-sso-name";

const BodyStyles = createGlobalStyle`
  body {
    background-color: ${({ theme }) => theme.colors.b10};
  }
`;
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ApolloProvider client={client}>
        <ThemeProvider>
          <I18nextProvider i18n={i18next}>
            <Elements
              stripe={loadStripe(
                process.env["REACT_APP_STRIPE_PUBLISH_KEY"] || ""
              )}
            >
              <ViewerProvider>
                <AlertsProvider>
                  <DropdownProvider>
                    <TooltipProvider>
                      <ModalProvider>
                        <GoogleMapsProvider>
                          <QuickTourProvider>
                            <ChecklistProvider>
                              <>
                                <ConfirmSsoNameModal />
                                <ConfirmUserTypeModal />
                                <BodyStyles />
                                <App />
                                <GuideHighlight />
                                <ToastContainer shiftTop={60} shiftRight={32} />
                              </>
                            </ChecklistProvider>
                          </QuickTourProvider>
                        </GoogleMapsProvider>
                      </ModalProvider>
                    </TooltipProvider>
                  </DropdownProvider>
                </AlertsProvider>
              </ViewerProvider>
            </Elements>
          </I18nextProvider>
        </ThemeProvider>
      </ApolloProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
